import { IDocumentSearchFindingPlace } from '../actions/get-search-orders-and-documents.action';
import { FINDING_PLACE_MAP } from '../configuration/document-order-search';
import { IDocumentSearchResources } from '../modules/document-search/document-search.props.autogenerated';

export const formatFindingPlace = (places: IDocumentSearchFindingPlace[] = [], resources: IDocumentSearchResources): string => {
    return places
        .map(p => {
            const key = FINDING_PLACE_MAP[p?.Id?.toString()];
            // eslint-disable-next-line security/detect-object-injection
            return key && key in resources ? resources[key as keyof IDocumentSearchResources] : 'Unknown';
        })
        .filter(Boolean)
        .join(', ');
};
